import { GET_ACCACCOUNT, GET_ACCACCOUNT_SUCCESS, GET_ACCACCOUNT_FAIL, DELETE_ACCACCOUNT, DELETE_ACCACCOUNT_SUCCESS, DELETE_ACCACCOUNT_FAIL, UPDATE_ACCACCOUNT, UPDATE_ACCACCOUNT_SUCCESS, UPDATE_ACCACCOUNT_FAIL, ADD_NEW_ACCACCOUNT, ADD_ACCACCOUNT_SUCCESS, ADD_ACCACCOUNT_FAIL, ACCACCOUNT_LOADING, ACCACCOUNT_RESET, GET_ACCACCOUNT_ONE } from "./actionType";

export const resetAccAccountState = (actionType) => ({
  type: ACCACCOUNT_RESET,
  payload: { actionType },
});

export const getAccAccountSuccess = (actionType, data) => ({
  type: GET_ACCACCOUNT_SUCCESS,
  payload: { actionType, data },
});

export const getAccAccountFail = (actionType, error) => ({
  type: GET_ACCACCOUNT_FAIL,
  payload: { actionType, error },
});

export const getAccAccount = (data) => ({
  type: GET_ACCACCOUNT,
  payload: data,
});

export const getAccAccountLoading = () => ({
  type: ACCACCOUNT_LOADING,
});

export const deleteAccAccount = (data) => ({
  type: DELETE_ACCACCOUNT,
  payload: data,
});

export const deleteAccAccountSuccess = (data) => ({
  type: DELETE_ACCACCOUNT_SUCCESS,
  payload: data,
});

export const deleteAccAccountFail = (error) => ({
  type: DELETE_ACCACCOUNT_FAIL,
  payload: error,
});

export const updateAccAccount = (data) => ({
  type: UPDATE_ACCACCOUNT,
  payload: data,
});

export const updateAccAccountFail = (error) => ({
  type: UPDATE_ACCACCOUNT_FAIL,
  payload: error,
});

export const updateAccAccountSuccess = (data) => ({
  type: UPDATE_ACCACCOUNT_SUCCESS,
  payload: data,
});

export const addNewAccAccount = (data) => ({
  type: ADD_NEW_ACCACCOUNT,
  payload: data,
});

export const addAccAccountSuccess = (data) => ({
  type: ADD_ACCACCOUNT_SUCCESS,
  payload: data,
});

export const addAccAccountFail = (error) => ({
  type: ADD_ACCACCOUNT_FAIL,
  payload: error,
});

export const getAccAccountOne = (data) => ({
  type: GET_ACCACCOUNT_ONE,
  payload: data,
});
